<template>
  <dropdown
    ref="dropdownRef"
    :title="TextAssistant.entityPluralName(entityType)"
    @open="handleDropdownOpen()"
  >
    <base-ifp-filter
      :label="TextAssistant.entityPluralName(entityType)"
      clearable
      @clear-clicked="clearSelectedIDs()"
    >
      <template #value-display>
        {{ selectedEntitiesLabel }}
      </template>
    </base-ifp-filter>
    <template #content>
      <div>
        <sleek-filter-input
          v-if="showFilterInput"
          ref="sleekFilterInputRef"
          v-model="filterQuery"
          :placeholder="`Search by name…`"
          show-small-text
        />
        <ul>
          <li v-for="entity in filteredOptions" :key="entity.id" @click="handleSelection(entity.id)">
            <i :class="entityIconClass(entity)" class="ddi" />
            <span :class="{ 'selected' : isSelected(entity.id) }">
              {{ entity.name }}
            </span>
          </li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */
import SearchableDropdownMixin from '@/mixins/searchable-dropdown.mixin'

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IProjectForSelection } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'IfpFilterEntities',

  extends: SearchableDropdownMixin,

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    entityOptions: {
      type: Array as () => IProjectForSelection[],
      required: true,
    },
  },

  data() {
    return {
      TextAssistant,
      showDropdown: false,

      /* SearchableDropdownMixin configuration */
      allowMultipleSelections: true,
    }
  },

  computed: {
    totalOptionsCount(): number {
      return this.entityOptions.length
    },
    filteredOptions(): IProjectForSelection[] {
      if (this.filterQuery.length === 0) {
        return this.entityOptions
      }

      return this.entityOptions.filter(entity => {
        return entity.name
          .toLowerCase()
          .includes(this.filterQuery.toLowerCase())
      })
    },
    selectedEntities(): IProjectForSelection[] {
      return this.entityOptions.filter(s => this.selectedIds.includes(s.id))
    },
    hasSelectedEntities(): boolean {
      return this.selectedEntities.length > 0
    },
    selectedEntitiesLabel(): string {
      if (!this.hasSelectedEntities) {
        return ''
      }
      if (this.selectedEntities.length === 1) {
        return this.selectedEntities[0].name
      }
      return `${this.selectedEntities.length} selected`
    },
  },

  methods: {
    entityIconClass(entity: IProjectForSelection): string {
      if (entity.isFavorite) {
        return `ddi ddi-star-filled`
      }
      return `ddi ddi-${TextAssistant.entitySingularName(
        this.entityType,
      ).toLowerCase()}`
    },
  },
})
</script>
